import React, { useContext, useState, useRef } from "react";
import { userContext } from "../../../../context/userContext";
import { environmentVariables } from "../../../../config/env.config";
import { useEffect } from "react";
import "./Theme71.css";
import Banner from "./../../../../Images/minimarketbg.png";
import LocationIcon from "./../../../../Images/locIcon.png";
import HomeComponent from "./HomeComponent";
import ContactInfo from "./ContactInfo";
import styled from "styled-components";
import { getContactInfo } from "../../../../utils/utility.js";
import axios from "axios";
import { useTranslation } from "react-i18next";
import tempLogo from '../../../../Images/constructionlogo.jpg'
import GalleryComponent from "./GalleryComponent.js";
import { BusinessSchedule } from "./BusinessSchedule.js";

const Theme71 = (props) => {
  const { t } = useTranslation();
  const { userData } = useContext(userContext);
  const [currentIndex, setCurrentIndex] = useState(0);
  const calendarInputRef = useRef(null);
  const [activeTab, setActiveTab] = useState("contactinfo");
console.log(props,'///////////////')
  const renderContent = () => {
    switch (activeTab) {
      case "home":
        return <div> <HomeComponent productdata={props} colordata={props} /> </div>;
      case "gallery":
        return <div> <GalleryComponent productdata={props} colordata={props} /> </div>;
      case "aboutus":
        return <div style={{ color: props?.dynamicTextHeadingColor ? `${props?.dynamicTextDescriptionColor}` : "" }} className="flex text-justify font-Tajawal text-[#101010] font-base text-lg"
          dangerouslySetInnerHTML={{
            __html: (props.description || `Our real estate platform features a wide selection of properties to suit every need and budget. From residential homes to commercial spaces, we offer a seamless experience for buyers, renters, and investors looking for quality real estate opportunities.`).replace(/(?:\r\n|\r|\n)/g, '<br>'),
          }}>

        </div>;
      case "schedule":
         return <div> <BusinessSchedule props={props} /> </div>;
      default:
       return <div><ContactInfo contdata={props} colordata={props} /></div>;
    }
  };

  useEffect(() => {
    getBlockOrder();
  }, [props?.businessObj, props.businessId, props.orderOfBlocks]);
  const getBrandNameForSocial = (brand) => {
    if (brand == "gmail") {
      return "google";
    } else return `${brand}`;
  };
  const getBlockOrder = async () => {
    // const handleGetBlock = async () => {
    if (props.orderOfBlocks) {
      let orders = {};
      props.orderOfBlocks.map((val) => {
        if (val.content == "Description") {
          orders["description"] = val?.position;
        } else if (val.content == "Contact Info") {
          orders["contact_info"] = val?.position;
        } else if (val.content == "Appointment") {
          orders["appointment"] = val?.position;
        } else if (val.content == "Service") {
          orders["service"] = val?.position;
        } else if (val.content == "Gallery") {
          orders["gallery"] = val.position;
        } else if (val.content == "Contact Form") {
          orders["contact_form"] = val.position;
        } else if (val.content == "Testimonials") {
          orders["testimonials"] = val.position;
        } else if (val.content == "Social") {
          orders["social"] = val.position;
        } else if (val.content == "Business Hour") {
          orders["business_hour"] = val.position;
        }
      });
      props.setOrder(orders);
    } else {
      try {
        let id = props?.businessObj?.id || props.businessId;
        if (props?.businessObj?.id) {
          let { data: get } = await axios.get(
            `${environmentVariables?.apiUrl}api/v1/business/FetchBlock?business_id=${id}`,
            {
              headers: {
                _token: userData?.token,
              },
              // withCredentials: true,
            }
          );
          // console.log(get?.data?.order, "order data");
          props.setOrder(get?.data?.order);
        }

        // console.log(get.data.order,"Getetgwef")
      } catch (err) {
        console.log(err, "error in template");
      }
    }
    // };
  };


  // const getCorrectDay = (day) => {
  //   const dayMappings = {
  //       WednesDay: "Wednesday",
  //     thrusdayDay: "Thursday",
  //     fridayDay: "Friday",
  //     saturdayDay: "Saturday",
  //     sundayDay: "Sunday",
  //   };

  //   return dayMappings[day] || day;
  // };

  // const getOpeningHours = (businessHourObject) => {
  //   let daysOfWeek = ["Monday", "Tuesday", "WednesDay", "thrusdayDay", "fridayDay", "saturdayDay", "sundayDay"];
  //   let startDay = null;
  //   let endDay = null;
  //   let closedDays = [];

  //   // Find the first and last true values in businessHourObject
  //   for (let day of daysOfWeek) {
  //     if (businessHourObject[`is${day}`]) {
  //       if (!startDay) startDay = day;
  //       endDay = day;
  //     } else {
  //       closedDays.push(day);
  //     }
  //   }

  //   // Replace misspelled days with correct spellings
  //   startDay = getCorrectDay(startDay);
  //   endDay = getCorrectDay(endDay);

  //   // Construct opening hours string
  //   let openingHours = "";
  //   if (startDay && endDay) {
  //     openingHours = startDay === endDay ? startDay : `${startDay} - ${endDay}`;
  //   } else if (startDay) {
  //     openingHours = startDay;
  //   }

  //   let closedDaysString = "";
  //   if (closedDays.length > 0) {
  //     closedDaysString = closedDays.map((day) => getCorrectDay(day)).join(", ");
  //   }

  //   return { openingHours, closedDays: closedDaysString };
  // };

  // const { openingHours, closedDays } = getOpeningHours(props.businessHourObject);

  return (
    <div>
     <style>
    {`
      #temp71 .miniMenuActive {
        color: ${props?.dynamicCtaColor ||'#ff6933'};
        border-bottom: 2px solid ${props?.dynamicCtaColor || '#ff6933'} !important;
        margin-bottom: -2px;
        font-weight:600
      }

      #temp71 .miniMenuInactive {
        color: ${props?.dynamicTextHeadingColor  || "#6b7280" };
        margin-bottom: -2px;

      }

      #temp71 .miniMenuInactive:hover {
        color: ${props?.dynamicCtaColor || '#ff6933'};
        border-bottom: 2px solid ${props?.dynamicCtaColor} !important;
      }
    `}
  </style>
      <div class="main-temaplt" id="temp71">
        <div className="container">
          <div className="row justify-content-center">
            <div style={{ width: "420px", maxHeight: "none", background: props?.dynamicMainBackgroundColor }} className="col-12 wtemplate p-4" >
              <div class="propertyUpper"></div>
              <div>
                <div className="propertyMinimktheader">

                                      <div className="userData">
                  
                                      <img src={props?.logoImageUrl ? props?.getImage(props?.logoImageUrl) : tempLogo} className="avatar" />
                                      <div className="propertyUser">
                                        <h3>{props?.subTitle}</h3>
                                        <h6>{props?.designation}</h6>
                                        <p>{props?.title}</p>
                                      </div>
                  
                                    </div>

                </div>

                <div className="p-0  mx-0 mb-3 flex justify-start items-center " style={{ color: `${props?.dynamicTextHeadingColor || '#CCCCCC'}` ,borderBottom: `1px solid ${props?.dynamicTextHeadingColor || "#ccc"}` }}>
                  {(props?.onState?.contactInfo || props?.onState?.socials) && (
                  
                      <div
                        style={{ minWidth: "25%"}} className={`mt-3 pb-1 text-lg text-center cursor-pointer hover:font-bold hover:text-coffee hover:transition all ${activeTab === "contactinfo"
                          ? `miniMenuActive`
                          : 'miniMenuInactive'
                          }`}
                          onClick={() => setActiveTab("contactinfo")}
                      >
                        {props?.contactHeading || t("Contact")}
                      </div>
                  
                  )}
                  {props?.onState?.realestatePortfolio && (
                  
                      <div
                        style={{ minWidth: "25%"}} className={` mt-3 pb-1 px-2  text-lg cursor-pointer text-center hover:font-bold  hover:transition all ${activeTab === "home"
                          ? `miniMenuActive`
                          : 'miniMenuInactive'
                          }`}
                        onClick={() => setActiveTab("home")}
                      >
                        {t("Properties")}
                      </div>
                  
                  )}
                  
                  {props?.onState?.realestatePortfolio && (
                  
                      <div
                        style={{ minWidth: "25%"}} className={` mt-3 pb-1 px-2  text-lg cursor-pointer text-center hover:font-bold  hover:transition all ${activeTab === "gallery"
                          ? `miniMenuActive`
                          : 'miniMenuInactive'
                          }`}
                        onClick={() => setActiveTab("gallery")}
                      >
                        {t("Gallery")}
                      </div>
                  
                  )}
                 
                    {/* <div
                      style={{ minWidth: "25%"}} className={`mt-3 pb-1  text-lg cursor-pointer text-center hover:font-bold hover:text-coffee hover:transition all ${activeTab === "aboutus"
                        ? `miniMenuActive`
                          : 'miniMenuInactive'
                        }`}
                      onClick={() => setActiveTab("aboutus")}
                    >
                      {props.descriptionHeading ? props.descriptionHeading :t("About_us")}
                    </div> */}

                  {props?.onState?.appointment && (
                    <div
                      style={{ minWidth: "25%"}} className={`mt-3 pb-1  text-lg cursor-pointer text-center hover:font-bold hover:text-coffee hover:transition all ${activeTab === "schedule"
                        ? `miniMenuActive`
                          : 'miniMenuInactive'
                        }`}
                      onClick={() => setActiveTab("schedule")}
                    >
                      {t("Schedule")}
                    </div>
                 
                      )}
                </div>


                <div className="px-2 py-2">{renderContent()}</div>

              </div>
              {/* <div className=' bg-white px-2 py-4 sticky spacing -bottom-25 w-full text-center'>
                <button className='bg-coffee text-xl rounded text-white w-full font-bold font-Tajawal pt-3  p-2'>
                  Contact supplier
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Theme71;
